import { RemoteConfigProperties } from "../../../../..";
import { NotImplementedError } from "../../../../../errors";
import { PromiseHandler } from "../../../../../handlers";
import { parseDateFilter, requireAdvertiserIdFilter, requireAnalysisInterval } from "../../../../../models/looker/modules/attribution";
import { toEmbedHash } from "../../../../../models/looker/query";
import { FILTER_OPTIONS_COMMERCIAL_QUERY } from "../query";
export default class LookerAttributionCommercialFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-attribution-commercial-filter");
    }
    async findItems(filters) {
        if (this.sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.REPORTING_API_ATTRIBUTION_FILTERS)) {
            return this.findItemsFromReportingApi(filters);
        }
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const parsedDateFilter = parseDateFilter(dateFilter);
        const advertiserIdFilter = filters.where?.find((filter) => filter.field === "advertiser")?.value;
        if (!advertiserIdFilter) {
            throw new Error("Advertiser ID filter is required");
        }
        const queryBody = {
            ...FILTER_OPTIONS_COMMERCIAL_QUERY,
            filters: {
                "conversion_linear_suggests.flt_date_nyc": parsedDateFilter,
                "conversion_linear_suggests.advertiser_id": advertiserIdFilter
            }
        };
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatCommercialResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch conversion dashboard linear commercial filter options");
        }));
    }
    /**
     * The same rows through the reporting API instead of the Looker SDK, in the
     * same shape, so no caller can tell which source answered.
     */
    async findItemsFromReportingApi(filters) {
        const analysisInterval = requireAnalysisInterval(filters.where);
        const advertiserIdFilter = requireAdvertiserIdFilter(filters.where);
        const request = {
            fields: ["creative_id", "creative_name"],
            filters: {
                analysis_interval: analysisInterval,
                advertiser_id: advertiserIdFilter
            },
            sorts: ["creative_name asc"],
            limit: -1
        };
        const hashKey = `api:${await this.sdk.looker.query.hashQuery(request)}`;
        return this.cache.promise(hashKey, () => this.sdk.looker.reporting
            .query("/attribution/linear/filter-options", request, "Failed to fetch conversion dashboard linear commercial filter options.")
            .then(({ data, query }) => [
            {
                data: this.formatCommercialApiResponse(data),
                queryMeta: { embedHash: toEmbedHash(query?.share_url) }
            }
        ]));
    }
    formatCommercialApiResponse(rows) {
        const seenCreativeIds = new Set();
        const creatives = [];
        rows.forEach((row) => {
            const creativeId = row.creative_id;
            const creativeName = row.creative_name;
            if (creativeId && !seenCreativeIds.has(creativeId)) {
                creatives.push({
                    name: creativeName ?? "",
                    id: creativeId
                });
                seenCreativeIds.add(creativeId);
            }
        });
        return creatives;
    }
    formatCommercialResponse(data) {
        const seenCreativeIds = new Set();
        const creatives = [];
        data.forEach((creative) => {
            const creativeId = creative["conversion_linear_suggests.creative_id"];
            const creativeName = creative["conversion_linear_suggests.creative_name"];
            if (creativeId && !seenCreativeIds.has(creativeId)) {
                creatives.push({
                    name: creativeName,
                    id: creativeId
                });
                seenCreativeIds.add(creativeId);
            }
        });
        return creatives;
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Commercial.js.map